import React, { Component } from 'react';
import { useParams } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import Table from 'react-bootstrap/Table';
import apiCallsHelper from '../../api/apiCallsHelper';
import config from '../../common/config';

class PublicFcraAuthComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authorization: null,
      loading: true,
      error: null,
      submitting: false,
      fullName: '',
      errors: {}
    };
  }

  async componentDidMount() {
    try {
      const { unique } = this.props.params;
      const result = await apiCallsHelper.post(
        `${config.trueFingerPrintsAPI.baseURL}/authorization/${unique}`
      );

      if (result && result.data) {
        this.setState({
          authorization: result.data.authorization,
          loading: false
        });
      }
    } catch (error) {
      this.setState({
        error: error.data?.message || error.message || 'Failed to load authorization',
        loading: false
      });
    }
  }

  validateForm = () => {
    const errors = {};
    if (!this.state.fullName || this.state.fullName.trim().length < 3) {
      errors.fullName = 'Full name is required and must be at least 3 characters';
    }
    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleSign = async () => {
    if (!this.validateForm()) {
      return;
    }

    this.setState({ submitting: true, error: null, errors: {} });

    try {
      const { unique } = this.props.params;
      const req = {
        fullName: this.state.fullName,
        unique: unique
      };

      const result = await apiCallsHelper.post(
        `${config.trueFingerPrintsAPI.baseURL}/authorization/sign`,
        req
      );

      if (result && result.status === 200) {
        // Reload authorization data to show signed state
        const updatedAuth = await apiCallsHelper.post(
          `${config.trueFingerPrintsAPI.baseURL}/authorization/${unique}`
        );

        this.setState({
          authorization: updatedAuth.data.authorization,
          submitting: false
        });
      }
    } catch (error) {
      this.setState({
        error: error.data?.message || error.message || 'Failed to submit authorization',
        submitting: false
      });
    }
  };

  render() {
    const { loading, error, authorization, submitting, errors } = this.state;
    const { unique } = this.props.params;

    if (loading) {
      return (
        <Container className="mt-5 text-center">
          <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        </Container>
      );
    }

    if (error && !authorization) {
      return (
        <Container className="mt-5">
          <Alert variant="danger">
            <Alert.Heading>Error</Alert.Heading>
            <p>{error}</p>
          </Alert>
        </Container>
      );
    }

    if (!authorization) {
      return (
        <Container className="mt-5">
          <Alert variant="warning">
            <Alert.Heading>Not Found</Alert.Heading>
            <p>Authorization request not found.</p>
          </Alert>
        </Container>
      );
    }

    const date = authorization.updatedAt ? new Date(authorization.updatedAt) : null;

    return (
      <div>
        <Row className='box-section banner'>
          <Col className='text-group' sm={12} md={12}>
            <div className='banner-text-group fcra-header'>
              <h1 className='headline mb-2 mt-3'>
                Authorization to Obtain Consumer Report (Background/Credit Check)
              </h1>
            </div>
          </Col>
        </Row>

        <Container>
          <div className='text-box'>
            <h3 className='headline mb-2  mt-5'>
              DISCLOSURE REGARDING BACKGROUND INVESTIGATION
            </h3>
            <p className='text-justify'>
              Personnelgraph may obtain a consumer report about you for employment purposes. A consumer report may contain information regarding your criminal history, creditworthiness, credit standing, credit capacity, character, general reputation, personal characteristics, or mode of living.
              <br /><br />
              If an investigative consumer report is obtained (one based on personal interviews), you have the right to request additional information about the nature and scope of the investigation
              <br /><br />
              This disclosure is provided in accordance with the Fair Credit Reporting Act (15 U.S.C. §1681 et seq.).
            </p>
            <h3 className='headline mb-2 mt-3'>
              AUTHORIZATION FOR BACKGROUND CHECK
            </h3>
            <p className='text-justify'>
              I acknowledge that I have received and read the above Disclosure Regarding Background Investigation
              and understand that, as a condition of my employment or continued employment,
              Personnelgraph may obtain consumer reports and/or investigative consumer reports
              about me from a consumer reporting agency.
              <br /><br />
              I hereby authorize the procurement of such reports for employment purposes. This authorization shall remain valid throughout my employment, unless revoked in writing to the extent permitted by law.
              <br /><br />
              I understand I have rights under the Fair Credit Reporting Act, including the right to request and receive information about the nature and scope of any investigative consumer report, and the right to dispute any inaccurate or incomplete information.
            </p>
            <h3 className='headline mb-2 mt-3'>
              STATE-SPECIFIC DISCLOSURES
            </h3>
            <p className='text-justify'>
              The following additional rights and disclosures apply if you live in, or are applying for a position in, the listed states:
              <br /><br />
              California<br />
              Under California law, you have the right to request a copy of any consumer report or investigative consumer report obtained about you by the employer. If an investigative consumer report is ordered, you will receive a notice with more information and a summary of your rights under California law.
              <br /><br />
              Minnesota
              <br /> You have the right to request a copy of any consumer report obtained about you by the employer.
              <br /><br />
              Oklahoma <br />
              You have the right to request a copy of any consumer report obtained about you by the employer.
              <br /><br />
              New York <br />
              You have the right to be informed if a consumer report is requested about you. Upon written request, you will be informed whether such a report was requested and, if so, provided with the name and address of the consumer reporting agency. You are also being provided a copy of Article 23-A of the New York Correction Law, which relates to the employment of individuals with criminal records.
              <br /><br />
              Washington State <br />
              You have the right to request a written summary of your rights and remedies under Washington law if an investigative consumer report is obtained.
            </p>
            <h3 className='headline mb-2 mt-3'>
                SIGNATURE
            </h3>
            <br/>
            <div>
            <p className='d-block'>
              By electronically signing below, I acknowledge the following:
            </p>
            </div>
            <ul>
              <li>I have received and read the Disclosure Regarding Background Investigation</li>
              <li>I authorize Personnelgraph to obtain consumer and/or investigative consumer reports as described above</li>
              <li>I understand my rights under federal and applicable state law</li>
            </ul>
            <h6 className='text-center'>FCRA Auth ID:  {unique}</h6>
          </div>

          {error && (
            <Row className="mt-3">
              <Col>
                <Alert variant="danger">{error}</Alert>
              </Col>
            </Row>
          )}

          {!authorization.sign ? (
            <Row className='authorize w-75 mx-auto bg-transparent mb-3'>
              <Col className='text-group' lg={12}>
                <Form>
                  <Form.Group controlId='formGroupName'>
                    <Form.Control
                      type='text'
                      placeholder='Full Name'
                      onChange={(e) => this.setState({ fullName: e.target.value })}
                      name='name'
                      value={this.state.fullName}
                    />
                    <div className='errors'>
                      {errors && errors.fullName ? errors.fullName : null}
                    </div>
                  </Form.Group>
                  <div className='d-flex justify-content-center'>
                  <Button
                    className='mt-4 mb-5'
                    variant='primary'
                    size='lg'
                    onClick={this.handleSign}
                    disabled={submitting}
                  >
                    {submitting ? 'Submitting...' : 'Sign & Authorize'}
                  </Button>
                  </div>
                </Form>
              </Col>
            </Row>
          ) : null}

          {authorization.sign ? (
            <Row className='box-section mt-1 mb-5'>
              <Col className='text-group' sm={12} md={12}>
                <h5 className='py-5 px-5 notice-success'>
                  Authorization completed and signed by {authorization.sign} on {date ? date.toLocaleString("en-US") : 'N/A'}.
                </h5>
              </Col>
            </Row>
          ) : null}

          {!authorization.sign ? (
            <Row className="table-section">
              <Col lg={12}>
                <section className="list-box mt-3">
                  <Table responsive="xl" className="mb-5">
                    <thead>
                      <tr>
                        <th>Additional Documents</th>
                        <th>Format</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>A Summary of Your Rights Under the Fair Credit Reporting Act</td>
                        <td>pdf</td>
                        <td>
                          <a href="/pdf/bcfp_consumer-rights-summary_2018-09.pdf" target="_blank" rel="noopener noreferrer">
                            <Button variant="outline-primary">
                              View
                            </Button>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>Remedying the Effects of Identity Theft</td>
                        <td>pdf</td>
                        <td>
                          <a href="/pdf/Remedying the Effects of Identity Theft.pdf" target="_blank" rel="noopener noreferrer">
                            <Button variant="outline-primary">
                              View
                            </Button>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>Remedying the Effects of Identity Theft Spanish</td>
                        <td>pdf</td>
                        <td>
                          <a href="/pdf/Remedying the Effects of Identity Theft Spanish.pdf" target="_blank" rel="noopener noreferrer">
                            <Button variant="outline-primary">
                              View
                            </Button>
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>California San Francisco OLSE Notice</td>
                        <td>pdf</td>
                        <td>
                          <a href="/pdf/California San Francisco OLSE Notice.pdf" target="_blank" rel="noopener noreferrer">
                            <Button variant="outline-primary">
                              View
                            </Button>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </section>
              </Col>
            </Row>
          ) : null}
        </Container>
      </div>
    );
  }
}

// Wrapper to use hooks with class component
const PublicFcraAuth = (props) => {
  const params = useParams();
  return <PublicFcraAuthComponent {...props} params={params} />;
};

export default PublicFcraAuth;
